import { request } from "../../utils/config"
export const GET_PRODUCT_UNITS = async (name: string) => {
  const response = await request({
    url: `productUnits?SearchText=${name}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_PRODUCT_UNIT = async (id: string) => {
  const response = await request({
    url: `productUnits/${id}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
